import type { ReactNode } from 'react';
import { TypedConfirmDialog, DELETE_WORD, confirmationMatches } from './ui/ConfirmDialog';

/**
 * Confirmação de ação destrutiva, em português. Proteção contra acidente:
 * o botão só libera depois de digitar DELETE ou o nome do item (ou o texto
 * exato pedido em requiredText).
 *
 * A implementação mora em `ui/ConfirmDialog` (`TypedConfirmDialog`); este
 * arquivo é só a fachada com o nome e as props que os ~30 call sites já
 * usam — por isso `DELETE_WORD` e `confirmationMatches` continuam exportados
 * daqui.
 */
export { DELETE_WORD, confirmationMatches };

interface DangerConfirmModalProps {
  open: boolean;
  title: string;
  children: ReactNode;
  confirmText: string;
  /** Texto exato a digitar (ex.: ESQUECER). Sem ele, vale "DELETE" ou o nome do item */
  requiredText?: string;
  /** Nome do que vai ser excluído: digitar o nome também libera o botão */
  objectName?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DangerConfirmModal({ open, title, children, confirmText, requiredText, objectName, onConfirm, onCancel }: DangerConfirmModalProps) {
  return (
    <TypedConfirmDialog
      open={open}
      title={title}
      confirmText={confirmText}
      requiredText={requiredText}
      objectName={objectName}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      {children}
    </TypedConfirmDialog>
  );
}
